document.addEventListener('DOMContentLoaded', () => {

    // Unix timestamp (in seconds) to count down to
    if (new Date() < new Date("2025-12-08T09:59:59")) {
        var date = new Date("2025-12-08T09:59:59");
    } else if (new Date() < new Date("2025-12-16T23:59:59")) {
        var date = new Date("2025-12-16T23:59:59");
    } else if (new Date() < new Date("2025-12-24T23:59:59")) {
        var date = new Date("2025-12-24T23:59:59");
    } else {
        var date = new Date("2026-01-01T00:00:00");
    }

    if ((date.getTime()-new Date().getTime())<259200000) document.getElementById("flipdown").classList.add("late");

    // Set up FlipDown
    var timeFromNow = (date.getTime() / 1000);

    var flipdown = new FlipDown(timeFromNow, {
        theme: "dark", headings: ["dní", "hodin", "minut", "sekund"]
      })
      .start()
      .ifEnded(() => {
        console.log('The countdown has ended!');
      });

  });


/* Run only when "isHpPage" is true */
if (document.querySelectorAll(".js-page-hp").length > 0) {
  // Floating button START
  var elements = document.querySelectorAll("[class^=vyzva-button]");
  var floating = document.getElementById("floatingButton");

  function checkVisible(elm) {
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      var visibility = [];
      elm.forEach(element => {
          var rect = element.getBoundingClientRect();
          visibility.push(!(rect.bottom < 0 || rect.top - viewHeight >= 0));
      });
      return visibility.includes(true);
  }


  window.onscroll = function() {
      floating.style.display = checkVisible(elements) ? 'none' : 'block';
  };
  // Floating button END
}

//START Copy
function copyClipboard($input_name) {
  var value = document.querySelector("input[name=cv_" + $input_name + "").value;
  if (navigator.clipboard) {
      navigator.clipboard.writeText(value);
  }

  //console.log("copied: " + value);
}
window.copyClipboard = copyClipboard;

function showCopySuccess(el) {
    let span = el.querySelector(".copy-success");
    span.textContent = "zkopírováno";
    span.classList.remove("tw-hidden");

    setTimeout(() => {
        span.classList.add("tw-hidden");
    }, 2000);
}

window.showCopySuccess = showCopySuccess;
//END Copy

// popups START
if (typeof window.$popup_opened === "undefined") {
  window.$popup_opened = false;
}

function openPopupByName(name) {
  if (window.$popup_opened) {
      return;
  }

  window.$popup_opened = true;

  const popupEl = document.querySelector(`*[data-popupname="${name}"]`);

  if (popupEl) {
      const parent = popupEl.parentElement;
      parent.classList.remove("inactive-modal");

      const closerBackground = parent.querySelector(".js-popups-closer-background");
      if (closerBackground) {
          closerBackground.style.display = "block";
          closerBackground.style.opacity = "0";
          setTimeout(() => {
              closerBackground.style.opacity = "1";
              closerBackground.style.transition = "opacity 0.3s";
          }, 10);
      }

      popupEl.classList.add("js-popup-shown");
      popupEl.style.display = "block";
      popupEl.style.opacity = "0";
      setTimeout(() => {
          popupEl.style.opacity = "1";
          popupEl.style.transition = "opacity 0.3s";
      }, 10);

      lockScroll();
  }
}
window.openPopupByName = openPopupByName;

// Auto-open popups
document.querySelectorAll('[data-auto-open="true"]').forEach((element) => {
  const popupId = element.getAttribute("data-popup-id");
  openPopupByName(`popup-${popupId}`);
});

// Trigger for opening popups
function addOnClickToPopupTriggers() {
  const popupTriggers = document.querySelectorAll(".js-popup-trigger");

  popupTriggers.forEach((trigger) => {
      trigger.onclick = function () {
        const popupName = trigger.getAttribute("data-popupshow");
        openPopupByName(popupName);
      };
  });
}
addOnClickToPopupTriggers();

// Close active popup
window.closeActivePopup = function () {
  if (window.$popup_opened) {
      window.$popup_opened = false;

      document.querySelectorAll(".js-popups-closer-background").forEach((el) => {
          el.style.opacity = "0";
          el.addEventListener("transitionend", () => {
              el.style.display = "none";
              if (el.parentElement) {
                  el.parentElement.classList.add("inactive-modal");
              }
          }, { once: true });
      });

      document.querySelectorAll(".js-popup-shown").forEach((el) => {
          el.style.opacity = "0";
          el.addEventListener("transitionend", () => {
              el.style.display = "none";
              el.classList.remove("js-popup-shown");
          }, { once: true });
      });

      unlockScroll();
  }
};

// Close popup by click
document.addEventListener("click", (event) => {
  if (event.target.closest(".js-popup-close")) {
      closeActivePopup();
  }
});

// Specific close button
document.querySelectorAll(".popup-close-button").forEach((button) => {
  button.addEventListener("click", () => {
      if (window.$popup_opened) {
          window.$popup_opened = false;

          document.querySelectorAll(".popups-closer-background").forEach((el) => {
              el.style.opacity = "0";
              el.addEventListener("transitionend", () => {
                  el.style.display = "none";
              }, { once: true });
          });

          document.querySelectorAll(".popup-shown").forEach((el) => {
              el.style.opacity = "0";
              el.addEventListener("transitionend", () => {
                  el.style.display = "none";
                  el.classList.remove("popup-shown");
              }, { once: true });
          });

          unlockScroll();
      }
  });
});
// popups END

// Helper functions
function lockScroll() {
  document.body.style.overflow = "hidden";
}

function unlockScroll() {
  document.body.style.overflow = "";
}
